<template>
    <div class="employees">

        <box-helper
            headline="Medarbejdere"
            identifier="employees"
        />

        <div class="container section">
            <title-block headline="<b>Medarbejdere</b>" class="mb-xl" position="center">
                <p slot="text">
                    Ét samlet overblik over dine medarbejdere
                </p>
            </title-block>

            <!--<view-toggle
                operationsName="Drift"
                operationsLink="EmployeesOperations"
                learningName="Udvikling / læring"
                learningLink="EmployeesLearning"
                v-if="$route.name === 'EmployeesOperations'"
            />-->

            <router-view />
            
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            showHelper: false
        }
    }
}
</script>



// WEBPACK FOOTER //
// employees.vue?cc12e1d0